<template>
    <div class="or-admin-production">
        <div v-show="!selected_category">
            <or-admin-category-card class="card nesting-main" :options="category" @remove="remove(i)" @up="up(i)" @down="down(i)" @selected="select(category)" @unsaved="unsaved" v-for="(category, i) in options" :key="category.id"/>
            <p class="add nesting-main hover-pointer hover-yellow" @click="add">+ Добавить категорию</p>
        </div>
        <div class="category_content nesting-main" v-if="selected_category">
            <div class="products-title flex-row">
                <p class="text">Продукты категории</p>
                <p class="category">{{selected_category.value}}:</p>
                <p class="move hover-pointer hover-yellow" @click="selected_category = null">Вернуться к категориям</p>
            </div>
            <div class="product flex-row row-ver-center nesting-main" v-for="(product, i) in  products" :key="product.id">
                <p class="name">{{product.name}}</p>
                <p class="move hover-pointer hover-yellow" @click="up_product(i)">Выше</p>
                <p class="move hover-pointer hover-yellow" @click="down_product(i)">Ниже</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminCategoryCard from '../global/or-admin-category-card.vue'
export default {
    components: {orAdminCategoryCard},
    props: {
        options: Object,
        categories: Object,
        deleted: Array,
    },
    data() {
        return {
            selected_category: null,
        }
    },
    computed: {
        products() {
            const sorted = [];
            const category = this.categories[this.selected_category.id];
            if (!this.categories[this.selected_category.id]) return [];
            const products = category.products;
            products.map(product=>{
                sorted[category.products_sort.indexOf(product.id)] = product;
            })
            return sorted;
        }
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage'}),
        unsaved() {
            this.addUnsavedPage({page: 'production'})
        },
        add() {
            this.options.push({
                id: this.get_id(this.options),
                title: 'Название категории',
                value: 'Безымянная категория',
                image: null,
                products: [],
                products_sort: [],
                input_postfix: 'production',
            })
            this.addUnsavedPage({page: 'production'})
        },
        remove(index) {
            const deleted = this.options.splice(index, 1)[0];
            this.deleted.push(deleted.id);
            this.addUnsavedPage({page: 'production'})
        },
        up(index) {
            if (index === 0) return;
            const category = this.options.splice(index, 1)[0];
            this.options.splice(index - 1, 0, category);
            this.addUnsavedPage({page: 'production'})
        },
        down(index) {
            if (index === this.options.length - 1) return
            const category = this.options.splice(index, 1)[0];
            this.options.splice(index + 1, 0, category);
            this.addUnsavedPage({page: 'production'})
        },
        up_product(index) {
            const category = this.categories[this.selected_category.id];
            const products_sort = category.products_sort;
            if (index === 0) return;
            const product = products_sort.splice(index, 1)[0];
            products_sort.splice(index - 1, 0, product);
            this.addUnsavedPage({page: 'production'})
        },
        down_product(index) {
            const category = this.categories[this.selected_category.id];
            const products_sort = category.products_sort;
            if (index === products_sort.length - 1) return
            const product = products_sort.splice(index, 1)[0];
            products_sort.splice(index + 1, 0, product);
            this.addUnsavedPage({page: 'production'})
        },
        select(category) {
            this.selected_category = category;
            if (this.categories[this.selected_category.id]) {
                this.categories[this.selected_category.id].products.sort((a,b)=>{return a.production_category_index > b.production_category_index});
                this.categories[this.selected_category.id].products.map((el, index) => {el.production_category_index = index})
                this.categories[this.selected_category.id].products.sort((a,b)=>{return a.production_category_index > b.production_category_index});
            }
        },
        get_id(options) {
            let id = 0;
            options.map(el=>{
                if (el.id > id) {
                    id = el.id
                }
            })
            return id + 1;
        }
    }
    
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .add {
        font-size: 14px;
        line-height: 16px;
        margin-top: 50px;
        text-align: left;
        margin-bottom: 50px;
        color: #3dc986;
    }
    .add-product {
        margin: 0 0 0 25px;
    }
    .select {
        width: 400px;
        height: 40px;
        padding: 0 10px;
        border-radius: 8px;
        outline: none;
    }
    .text {
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        margin-bottom: 30px;
    }
    .category {
        font-size: 14px;
        line-height: 16px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 30px;
        margin-left: 10px;

    }
    .product {
        height: 10px;
    }
    .name {
        font-size: 14px;
        line-height: 16px;
    }
    .move {
        font-size: 14px;
        line-height: 16px;
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
</style>